import { Trans } from "@lingui/react/macro";
import React from "react";
import { Button } from "@silversea-ssc/ui-components-react";

interface ApplyButtonProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export const ApplyButton: React.FC<ApplyButtonProps> = ({ onClick }) => {
  return (
    <Button
      renderAs="button"
      variant="primary"
      onClick={onClick}
      full
      dataContentPiece="apply_button"
    >
      <Trans>Apply filters</Trans>
    </Button>
  );
};
